// Redux reducer for authentication state
const initialState = {
    isAuthenticated: false,
    user: null,
    loading: false,
    error: null,
    isTemporaryPassword: false,
    // 로그인 만료 — 작업 화면을 그대로 둔 채 그 위에 로그인 창을 띄운다(SessionExpiredGate).
    // 누구였는지(expiredUsrid)를 남겨, 다시 들어온 계정이 다르면 화면을 새로 불러온다(authActions.finishLogin).
    // 둘 다 redux-persist 에서 뺀다 — 남으면 새로고침 뒤에도 작업 화면 위에 로그인 창이 뜬다.
    sessionExpired: false,
    expiredUsrid: null
};

// Action Types
export const AUTH_ACTION_TYPES = {
    LOGIN_START: 'AUTH/LOGIN_START',
    LOGIN_SUCCESS: 'AUTH/LOGIN_SUCCESS',
    LOGIN_FAILURE: 'AUTH/LOGIN_FAILURE',
    LOGOUT: 'AUTH/LOGOUT',
    CLEAR_ERROR: 'AUTH/CLEAR_ERROR',
    PASSWORD_CHANGED: 'AUTH/PASSWORD_CHANGED',
    SESSION_EXPIRED: 'AUTH/SESSION_EXPIRED'
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_ACTION_TYPES.LOGIN_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case AUTH_ACTION_TYPES.LOGIN_SUCCESS:
            return {
                ...state,
                loading: false,
                isAuthenticated: true,
                user: action.payload.user || action.payload,
                isTemporaryPassword: action.payload.isTemporaryPassword || false,
                error: null,
                sessionExpired: false,
                expiredUsrid: null
            };
        case AUTH_ACTION_TYPES.LOGIN_FAILURE:
            return {
                ...state,
                loading: false,
                isAuthenticated: false,
                user: null,
                error: action.payload
            };
        case AUTH_ACTION_TYPES.LOGOUT:
            // loading 을 반드시 내린다. 로그아웃은 **모든 진행 중 상태의 종착점**이다.
            // 세션 복원(initializeAuth)이 LOGIN_START 로 시작해 "세션 없음" 으로 끝나면
            // 여기로 오는데, loading 을 놔두면 로그인 폼이 "로그인 중…" 으로 굳어
            // 입력조차 막힌다(= 사용자에게는 접속 불가로 보인다).
            return {
                ...state,
                loading: false,
                isAuthenticated: false,
                user: null,
                isTemporaryPassword: false,
                error: null,
                sessionExpired: false,
                expiredUsrid: null
            };
        case AUTH_ACTION_TYPES.SESSION_EXPIRED:
            // **로그아웃이 아니다.** 사용자 정보와 작업 화면은 그대로 두고 로그인 상태만 내린다 —
            // 같은 계정으로 다시 들어오면 하던 일이 그대로 이어져야 한다.
            return {
                ...state,
                loading: false,
                isAuthenticated: false,
                sessionExpired: true,
                expiredUsrid: (action.payload && action.payload.usrid) || null,
                error: null
            };
        case AUTH_ACTION_TYPES.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };
        case AUTH_ACTION_TYPES.PASSWORD_CHANGED:
            return {
                ...state,
                isTemporaryPassword: false
            };
        default:
            return state;
    }
};

export default authReducer;